<template>
    <div id="login">
        <v-app>
            <v-main>
                <v-container fluid fill-height>
                    <v-row justify="center" align="center">
                        <v-col cols="12" sm="8" md="6" lg="4">
                            <v-card class="elevation-12">
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title class="headline"
                                        >Inloggen</v-toolbar-title
                                    >
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <img width="100%" :src="logo" />
                                <v-divider></v-divider>
                                <v-card-text class="mt-3">
                                    <v-form>
                                        <span class="ml-8"> Username </span>
                                        <v-text-field
                                            v-on:keyup.enter="login"
                                            v-model="username"
                                            prepend-icon="person"
                                            name="username"
                                            id="username"
                                            type="text"
                                            class="pt-0"
                                        />
                                        <span class="ml-8"> Password </span>
                                        <v-text-field
                                            v-on:keyup.enter="login"
                                            v-model="password"
                                            prepend-icon="lock"
                                            :append-icon="
                                                show
                                                    ? 'visibility'
                                                    : 'visibility_off'
                                            "
                                            name="password"
                                            id="password"
                                            :type="show ? 'text' : 'password'"
                                            @click:append="show = !show"
                                            class="pt-0"
                                        />
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        width="77"
                                        color="primary"
                                        dark
                                        @click.stop="login"
                                        :loading="loading"
                                    >
                                        Login
                                    </v-btn>
                                </v-card-actions>
                                <v-alert
                                    v-model="alert"
                                    transition="slide-y-transition"
                                    type="error"
                                    dismissible
                                >
                                    {{ alertText }}
                                </v-alert>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-app>
    </div>
</template>

<script>
import logoDark from "../assets/logos/ft207_logo.png";

export default {
    data: () => ({
        show: false,
        username: "",
        password: "",
        dirtyEmail: null,
        dirtyPwd: null,
        loading: false,
        alert: false,
        alertText: "",
        color: "error",
        logo: logoDark,
    }),
    computed: {
        autoLogin() {
            return this.$store.getters.getAutoLogin;
        },
    },
    methods: {
        async login() {
            this.loading = true;
            try {
                await this.$store.dispatch("login", {
                    username: this.username,
                    password: this.password,
                });
                this.loading = false;
                this.$router.push("/");
            } catch (e) {
                this.alertText = e.message;
                this.loading = false;
                this.alert = true;
            }
        },
    },
    watch: {
        autoLogin(newVal) {
            if (newVal) {
                this.login();
                this.$store.commit("setAutoLogin", false);
            }
        },
    },
};
</script>
